import _ from "lodash";
import EventAPIKeyEditView from "@/components/Events/EventAPIKeyEditView/EventAPIKeyEditView.vue";
import APIKeyList from "@/components/Common/APIKeyList/APIKeyList.vue";
import ValidationDialog from "@/components/Common/ValidationDialog/ValidationDialog.vue";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import axios from "axios";

const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import { getTokenHeader } from "@/helpers/commonHelper";
import { checkPlz } from "@/configuration/formConfigurations";
import { uploadFile } from "@/helpers/fileHelper";
import "./EventAdmin.scss";

const defaultConfig = {
  contain_by_category_ids: [],
  contain_by_feature_ids: [],
  contain_by_feature_ids_for_top_chips: [],
  preFilterExcludeCategoryIds: [],
  preFilterExcludeFeatureIds: [],
  containByCategoryGroupIds: [],
  ipWhitelist: "",
  containByCategoryTypeIds: [],
  containByCategoryIds: [],
  containByFeatureIds: [],
  preSelectedCategories: [],
  preSelectedFeatures: [],
  preSelectedCity: "",
  showReleased: false,
  showHighlightToTop: false,
  showHighlight: false,
  showEventsWithTicketing: false,
  defaultSorting: false,
  defaultDirection: false,
  hitsPerPage: 10,
  startPage: 1,
  startOffset: 0,
  displayMap: false,
  showMap: true,
  showCopyright: true,
  showShortTitle: false,
  displayLocationDistrict: false,
  displayLocationCity: false,
  displayLocationCountry: false,
  displayCurrentlyOpen: false,
  subTitleInsteadOfDescription: false,
  fallbackPicture: null,
  outputFormat: "",
  selectedPrincipals: [],
  cityFilterTypes: ["normalized_city"],
  cityFilterLimitation: "doNotLimit",
  containByCity: undefined,
  containByNormalizedCity: undefined,
  hideSoftwareCopyright: false,
  alwaysShowCopyright: false,
  color: {
    "color-text": "#333",
    "color-primary": "#00636C",
    "color-hover": "#00636C",
    "color-secondary": "#5d7114",
    "color-accent": "#2468c9",
    "color-error": "#c55c52",
    "color-info": "#314d57",
    "color-success": "#00636C",
    "color-warning": "#c55c52",
    "map-pin-fill-color": "#257eca",
    "map-pin-stroke-color": "#2d5069",
    "map-pin-fill-color-active": "#c55c52",
    "map-pin-stroke-color-active": "#5d332f",
    "color-conversion": "#d32f2f"
  },
  locationDisplayMode: "city",
  showDistinctEventsCheckbox: false,
  distinctEvents: false,
  showCancelledEvents: true,
  newWidget: true,
  defaultCountry: "Deutschland",
  overlayMode: "dark",
  sliderMode: "sliderModeStandard",
  hideListOrGridToggle: false,
  showPriceOnImageInList: false,
  showCategoryInList: true,
  cardBorderRadius: 0,
  startDateDifference: 0,
  endDateDifference: 365,
  openAccordionPanels: "closed",
  showAccordionCaption: false,
  accessInformation: false,
  showShortDescription: false,
  hideShortDescriptionInDetailView: false,
  alternateOutput: "web",
  formUser: null,
  dataFormName: "",
  defaultRegionality: "regional",
  hidePrivacyPolicy: false,
  privacyPolicyLink: "",
  privacyPolicyText: "",
  mailSubject: "",
  mailText: "",
  dsgvoLink: "",
  requireImage: false,
  requireImageCopyright: false,
  requireImageAIAttribution: false,
  descriptionInfoText: "",
  groupFeaturesInGroups: false,
  dsgvoText:
    "Hier kann mit Deiner Einwilligung ein externer Inhalt angezeigt werden, der den redaktionellen Text ergänzt. Indem Du den Inhalt über „Akzeptieren und anzeigen“ aktivierst, kann der Anbieter der Videoplattform (z.B: YouTube) Informationen auf Deinem Gerät speichern oder abrufen und Deine personenbezogenen Daten erheben und verarbeiten, auch in Staaten außerhalb der EU mit einem niedrigeren Datenschutzniveau, worin Du ausdrücklich einwilligst. Die Einwilligung, kann von Dir wieder entzogen werden, indem Du Cookies & Cache löscht.",
  internComment: false,
  internInstruction: false,
  mailSenderName: "EO.Heimat",
  userPermission: "none",
  useHighlightFrom: "standard",
  hideCategoryFilter: false,
  showCategoryFilter: false,
  showLocationFilter: false,
  showTextSearch: false,
  textSearchLabel: "Textsuche",
  displayFiltersOutlined: false,
  hideDateFilter: false,
  isApp: false,
  hidePastEventAfterDays: 1
};

export default {
  name: "EventAdmin",
  data: () => ({
    dialog: false,
    editChannels: [],
    errorList: [],
    changedDescription: [],
    apiKeyValid: false,
    validationDialog: false,
    defaultChannelValues: ["web", "app", "print", "print2"],
    useHighlightFromItems: [
      { title: "Standard", value: "standard" },
      { title: "Eigen", value: "own" }
    ],
    ownChannelsToUpdate: [],
    editedKey: _.cloneDeep({ ...defaultConfig })
  }),
  async mounted() {
    await this.fetchData();
  },
  computed: {
    config() {
      return this.$store.state.eventConfig;
    },
    isReadOnlyApiKey() {
      if (this.isAdmin) {
        return false;
      }
      if (this.editedKey.userPermission === "edit") {
        return false;
      }
      return true;
    },
    apiKeys() {
      return this.config.apiKeys;
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    isEventAdmin() {
      return this.currentUser?.scopes?.includes("role:events_admin");
    },
    channels() {
      return this.$store.state.eventConfig.standard_channels;
    },
    allChannels() {
      return this.$store.state.eventConfig?.standard_channels?.concat(
        this.$store.state.eventConfig.own_channels
      );
    },
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    selectedPrincipalId() {
      return this.selectedPrincipal.id;
    }
  },
  watch: {
    async selectedPrincipalId() {
      await this.fetchData();
    },
    dialog(newState) {
      if (newState) {
        const defaultApiKeyConfig = this.getDefaultApiKeyConfig();
        if (!this.editedKey.color) {
          this.editedKey.color = defaultApiKeyConfig.color;
        } else if (
          Object.keys(this.editedKey.color).length !==
          Object.keys(defaultConfig.color).length
        ) {
          for (const key of Object.keys(defaultApiKeyConfig.color)) {
            if (!this.editedKey.color[key]) {
              this.editedKey.color[key] = defaultApiKeyConfig.color[key];
            }
          }
        }
        this.$nextTick(() => this.$refs.editView?.setCodePreview());
      }
    }
  },
  methods: {
    getPrincipalPaletteColors(moduleKey, widgetKey) {
      const colorPalette = this.$store.state.selectedPrincipal?.colorPalette;
      const colors = colorPalette?.[moduleKey]?.[widgetKey]?.colors;
      if (!Array.isArray(colors)) {
        return {};
      }
      return colors.reduce((acc, color) => {
        if (color?.key && color?.value) {
          acc[color.key] = color.value;
        }
        return acc;
      }, {});
    },
    getDefaultApiKeyConfig() {
      const baseConfig = _.cloneDeep(defaultConfig);
      baseConfig.color = {
        ...defaultConfig.color,
        ...this.getPrincipalPaletteColors("events", "widget")
      };
      return baseConfig;
    },
    isUnique(value) {
      return !(
        this.config.own_channels?.filter(channel => channel.value === value)
          ?.length > 1 || this.defaultChannelValues.includes(value)
      );
    },
    editOwnChannels(index) {
      if (!this.ownChannelsToUpdate.includes(index))
        this.ownChannelsToUpdate.push(index);
    },
    async updateApiKeyDescription(index) {
      try {
        const headers = getTokenHeader();
        const response = await axios.put(
          `${env.events_api_client_url}apiKey/${this.apiKeys[index]._id}`,
          this.apiKeys[index],
          { headers }
        );
        if (response.status === 200) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
        }
      } catch (e) {
        this.createError();
      }
    },
    async removeOwnChannel(index) {
      try {
        const confirm = await this.$confirm(
          "Möchten Sie diesen Kanal wirklich löschen?",
          confirmWarningConfig
        );
        if (confirm) {
          const channel = this.config.own_channels[index];
          if (channel?.new) {
            this.config.own_channels.splice(index, 1);
            return;
          }
          const headers = await getTokenHeader();
          const response = await axios.put(
            `${env.events_api_client_url}config/ownchannels`,
            {
              channel: channel.value,
              configId: this.config._id
            },
            { headers }
          );
          if (response.status === 200) {
            this.$store.dispatch("createSuccess", "Erfolgreich entfernt!");
            await this.$store.dispatch("getEventsConfig");
          } else {
            this.$store.dispatch(
              "createError",
              "Es ist ein unerwarteter Fehler aufgetreten!"
            );
          }
        }
      } catch (e) {
        this.$store.dispatch("createError", e);
      }
    },
    cleanupOwnChannels(save = false) {
      if (this.config?.own_channels?.length) {
        this.config.own_channels.map(channel => {
          channel.value = channel.value.toLowerCase();

          if (save) {
            const firstChar = channel.value[0];
            channel.icon = `${
              isNaN(firstChar) ? "alpha" : "numeric"
            }-${firstChar}-box-outline`;
            delete channel.new;
          }
        });
      }
    },
    gotOnlyNumsAndLetters(value) {
      const regex = /^[a-zA-Z0-9]+$/;
      return regex.test(value);
    },
    validateOwnChannels() {
      this.errorList = [];
      if (this.config.own_channels.length) {
        this.config.own_channels.forEach((channel, index) => {
          if (!this.gotOnlyNumsAndLetters(channel.value)) {
            this.validationDialog = true;
            this.errorList.push({
              field: `Kanal-Typ: ${channel.value} (${index + 1})`,
              validations: [
                "Typ darf keine Sonder- oder Leerzeichen enthalten!"
              ]
            });
          }
          if (!this.isUnique(channel.value)) {
            this.validationDialog = true;
            this.errorList.push({
              field: `Kanal-Typ: ${channel.value} (${index +
                1}) ist mehrfach vorhanden!`,
              validations: ["Muss einzigartig sein!"]
            });
          }
          if (!channel.value?.length) {
            this.validationDialog = true;
            this.errorList.push({
              field: `Kanal-Typ: ${index + 1}`,
              validations: ["Darf nicht leer sein!"]
            });
          }
        });
      }
    },
    async addApiKey() {
      try {
        const defaultApiKeyConfig = this.getDefaultApiKeyConfig();
        const newApiKey = {
          apiKey: String.random(),
          config_ref: this.config._id,
          description: "",
          ...defaultApiKeyConfig
        };
        const headers = getTokenHeader();
        await axios.post(`${env.events_api_client_url}apiKey/`, newApiKey, {
          headers
        });
        await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert!");
        await this.$store.dispatch("getEventsConfig");
      } catch (e) {
        this.createError();
      }
    },
    editChannel(index) {
      if (
        index !== null &&
        index !== undefined &&
        !this.editChannels.includes(index)
      )
        this.editChannels.push(index);
    },

    async removeApiKey(key) {
      try {
        const isConfirmed = await this.$confirm(
          "Wollen Sie diesen API Key wirklich löschen?",
          confirmWarningConfig
        );
        if (isConfirmed) {
          const headers = getTokenHeader();
          await axios.delete(`${env.events_api_client_url}apiKey/${key._id}`, {
            headers
          });
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          await this.$store.dispatch("getEventsConfig");
        }
      } catch (error) {
        await this.$store.dispatch("createError", error);
      }
    },
    async fetchData() {
      try {
        await this.$store.dispatch("getPrincipals");
        await this.$store.dispatch("getCategoryGroupsForEvents");
        await this.$store.dispatch("getFeatureGroupsForEvents");
        await this.$store.dispatch("getEventsConfig");
        await this.$store.dispatch("getAllUsers");
      } catch (ex) {
        await this.$store.dispatch("createError", ex);
      }
    },
    async apiKeyPreview(apiKey) {
      if (!this.isReadOnlyApiKey) {
        const confirmRes = await this.$confirm(
          `Möchten Sie Änderungen speichern?`,
          confirmWarningConfig
        );
        if (confirmRes) {
          await this.saveKey();
        }
      }
      await this.showApiKey(apiKey);
    },
    async showApiKey(apiKey) {
      let widgetUrl =
        this.$store.state.selectedPrincipal?.additional_data?.eventsWidgetUrl ??
        env.events_widget_api_url_v2;
      if (apiKey.newWidget) widgetUrl = env.events_widget_api_url_v2;
      window.open(`${widgetUrl}events?apiKey=${apiKey.apiKey}`, "_blank");
    },
    async copyApiKey(apiKey) {
      let clone = {
        ...apiKey,
        apiKey: String.random(),
        description: apiKey.description + " (Kopie)"
      };

      delete clone._id;
      delete clone.updatedBy;
      delete clone.createdBy;
      try {
        const headers = getTokenHeader();
        const response = await axios.post(
          `${env.events_api_client_url}apiKey/`,
          clone,
          {
            headers
          }
        );
        if (response.status === 201) {
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          await this.$store.dispatch("getEventsConfig");
        } else {
          this.createError();
        }
      } catch (e) {
        this.createError();
      }
    },
    editApiKey(index) {
      this.editedIndex = index;
      this.editedKey = Object.assign({}, this.getDefaultApiKeyConfig(), {
        ...this.apiKeys[index]
      });
      this.dialog = true;
    },
    closeKey() {
      this.editedIndex = null;
      this.editedKey = this.getDefaultApiKeyConfig();
      this.$refs.editView?.$refs?.fileInput?.reset();
      this.$refs.editView?.$refs?.logOverview?.resetLogs();
      this.dialog = false;
    },
    async saveKey(shouldCloseDialog) {
      if (this.isReadOnlyApiKey) {
        return;
      }
      if (this.apiKeyValid) {
        try {
          if (this?.editedKey?.fallbackPicture instanceof File) {
            this.editedKey.fallbackPicture = await this.uploadFile(
              this.editedKey.fallbackPicture,
              this.editedKey.apiKey,
              "events"
            );
          }

          if (!this.editedKey?.fallbackPicture?.url)
            this.editedKey.fallbackPicture = {};

          const headers = getTokenHeader();
          const response = await axios.put(
            `${env.events_api_client_url}apiKey/${this.editedKey._id}`,
            this.editedKey,
            {
              headers
            }
          );
          if (response.status === 200) {
            await this.$store.dispatch(
              "createSuccess",
              "Erfolgreich gespeichert!"
            );
          }
          await this.$store.dispatch("getEventsConfig");

          const logOverviewRef = this.$refs.editView?.$refs?.logOverview;
          const logsFetched = logOverviewRef?.logsFetched;
          logOverviewRef?.resetLogs();

          if (shouldCloseDialog) {
            this.closeKey();
          } else if (logsFetched) {
            logOverviewRef?.getLogs().then(null);
          }
        } catch (ex) {
          this.createError(ex);
        }
      } else this.createError("Bitte füllen sie alle Pflichtfelder aus");
    },
    createError(error) {
      this.snackbar = true;
      this.snackbarText =
        "Es ist ein Fehler aufgetreten. Bitte laden Sie die Seite neu oder versuchen Sie es später noch einmal";
      this.snackbarColor = "#c55c52";
      console.error(error);
    },
    addChangedDescription(index) {
      if (!this.changedDescription.includes(index))
        this.changedDescription.push(index);
    },
    async save() {
      if (!this.$refs.channelsForm.validate()) {
        return;
      }
      this.cleanupOwnChannels();
      this.validateOwnChannels();
      if (this.errorList?.length) return;
      this.cleanupOwnChannels(true);
      const headers = getTokenHeader();
      let method = "put";
      if (!this.config._id) method = "post";
      try {
        if (this.changedDescription.length) {
          await this.changedDescription.asyncForEach(
            async changedDescription => {
              await this.updateApiKeyDescription(changedDescription);
            }
          );
        }
        this.config.apiKeys.forEach((key, index) => {
          if (key.hidePastEventAfterDays <= 0) {
            this.config.apiKeys[index].hidePastEventAfterDays = 1;
          }
        });
        const res = await axios[method](
          `${env.events_api_client_url}config/`,
          this.config,
          { headers }
        );
        if (res.status === 200) {
          await this.fetchData();
          await this.$store.dispatch(
            "createSuccess",
            "Erfolgreich gespeichert!"
          );
          this.editChannels = [];
        } else await this.$store.dispatch("createError", res);
      } catch (ex) {
        await this.$store.dispatch("createError", ex);
      }
    },
    changeActiveChannelSelection(checkValue, channel) {
      if (checkValue) {
        if (!this.config.channels?.includes(channel))
          this.config.channels.push(channel);
      } else this.config.channels?.remove(channel);
    },
    changeDefaultChannelSelection(checkValue, channel) {
      if (checkValue) {
        if (!this.config.default_channels?.includes(channel))
          this.config.default_channels.push(channel);
      } else this.config.default_channels?.remove(channel);
    },
    checkPlz,
    uploadFile,
    moveUp(array, element) {
      this.move(array, element, -1);
    },
    moveDown(array, element) {
      this.move(array, element, 1);
    },
    move(array, element, delta) {
      let index = array.indexOf(element);
      let newIndex = index + delta;
      if (newIndex < 0 || newIndex === array.length) return;
      let indexes = [index, newIndex].sort();
      array.splice(indexes[0], 2, array[indexes[1]], array[indexes[0]]);
    }
  },
  components: { ValidationDialog, EventAPIKeyEditView, APIKeyList }
};
